import { useNavigate } from "react-router";

import { signOut } from "@/lib/auth-client";
import { trpc } from "@/lib/trpc";

export function useAppSignOut(redirectTo = "/") {
  const navigate = useNavigate();
  const utils = trpc.useUtils();

  return async () => {
    await signOut({
      fetchOptions: {
        onSuccess: () => {
          void utils.invalidate();
          window.location.assign(redirectTo);
        },
        onError: () => {
          navigate(redirectTo, { replace: true });
        },
      },
    });
  };
}
